<mat-dialog-actions>
    <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<div class="wrap">
    <span class="title">{{ 'PROPERTIES.TOOLTIPS.DOCUMENTS'|translate }}: {{ file_name }}</span>
    <img [src]="imageURL" alt="">
</div>